module.exports = __webpack_public_path__ + "static/media/Cardo-Bold.83611455.woff2";